import { Component, OnDestroy, OnInit } from '@angular/core';
import { constants } from '../../constants';
import { CommonUtilitiesService } from '../../common-utilities.service';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ComboWizardService } from "./combo-wizard.service";
import { DomSanitizer } from '@angular/platform-browser';
import { AuthGuardService } from '../../auth-guard/auth-guard.service';
import { MessageService } from '../../modal-info/modal-info.service';
import { Subscription } from 'rxjs';

//jquery var
declare var $: any;

@Component({
  selector: 'app-combo-wizard',
  templateUrl: './combo-wizard.component.html',
  styleUrls: ['./combo-wizard.component.scss'],
  providers: [MessageService]
})

export class ComboWizardComponent implements OnInit, OnDestroy {
  public RECARGAS: string = constants.FROM_RELOAD_PAGE;
  public CARE_CHANNELS_TITLE: string = this.LANG.getLangText("CARE_CHANNELS_FOOTER_TITTLE_GENERIC");

  band: any
  internal: any
  isShowModalPay = false;
  isComboRecurrentActive = false;
  actionUrl: any
  dataBrands: any
  //variable to show recurring payment actions
  /** show or hide recurrence and unique buttons */
  viewActionsRecurrent: boolean = false
  /** validate whether or not it is necessary to validate the existence of a recurring combo */
  validationComboRecurrent: boolean = false;
  validationComboOnly: boolean = false;
  validComboRecurrent = constants.VALID_COMBO_RECURRENT
  viewSaveCard: boolean = false

  messages: any[] = [];
  subscription: Subscription;


  //variables del wizard
  activeTab = 1;
  isNextStepReady = false;
  isBackDisabled = false;
  isStep1Checked = false;
  isStep2Checked = false;

  ///variables de modal
  isShowModal = false;
  isShowModalRecurrent = false;
  modalTitle = "";
  modalContent = "";
  recurrent = false;
  isModalReload = false;

  //form
  comboForm: FormGroup;
  labelBtnEnd = this.LANG.getLangText('PORTABILITY_LABEL_CONTINUE');
  isLoggedLines = false;
  isInputLineRegister = false;
  inOutSelected = 2;
  numericPattern = "";
  selectedAmouunt = 0;
  inputLine = null;
  selectedCard = null;
  isNewCard = false;
  isSaveCCard = false;
  isPayFrameShow = false;
  listLines = [];
  isLoadingBtn = false;
  cardList = [];
  isLoadingDeleteBtn = false;
  isHideBtn = false;
  isPaymentFormLoading = false;
  selectedPaymentMethod = 4;
  isLoadingBalance = false;
  lineBalance: any = "0";
  lineBalanceUnit: any = "";
  packageCode: any = "";
  paymentFinished = false;
  dateExecutedPatment: any = "";

  //variables de la pasarela de pagos
  paymentFormInputList = [];
  urlFormPayment = "";
  currentCombo = null;
  isComboInCart = true;
  idPackageDesc = "";
  validityCombon: any = "";
  paymentId = "";
  idTransaction = null;
  onResponseTecnocom: any;

  //constantes para la pantalla
  catBra = constants.COMBO_CATEGORY_BRAND;
  catMou = constants.COMBO_CATEGORY_MOUNT;
  catExp = constants.COMBO_CATEGORY_EXPRESS;

  //encendido o apagado de recurrencia
  isEnableRecurrence = false;

  constructor(
    public LANG: CommonUtilitiesService,
    private _router: Router,
    private formbuilder: FormBuilder,
    private comboWizardService: ComboWizardService,
    private _sanitizer: DomSanitizer,
    private messageService: MessageService,
    private authGuardService: AuthGuardService
  ) {

    this.subscription = this.messageService.getMessage().subscribe(message => {

      if (message) {
        if (message.text == this.LANG.getLangText('ONLY_ACTIVATE')) {
          this.validationComboRecurrent = false
          this.selectedPaymentMethod = 3
          this.changePaymentMethodClass(this.selectedPaymentMethod)
          this.nextStep()
        }
      }
    });

  }


  ngOnInit() {
    //mostrar parte superior
    $("html, body").animate({ scrollTop: 0 }, "slow");

    //se obtiene el combo/bono en cuestion
    this.currentCombo = JSON.parse(localStorage.getItem("shoppingCart"));

    this.selectedAmouunt = this.currentCombo.value;

    //si es bono
    if (this.currentCombo.bonuses == null || typeof this.currentCombo.bonuses === 'undefined') {
      this.isComboInCart = false;
      this.idPackageDesc = this.currentCombo.commercialDescription;
      this.validityCombon = this.currentCombo.validityDays + " " + this.currentCombo.validityType;
      this.packageCode = this.currentCombo.idSlo;
      this.currentCombo.nslist = this.currentCombo.socialNet.split("-");
      this.paymentId = this.currentCombo.idPaymentManager;
    } else {
      //si es combo
      this.validityCombon = this.currentCombo.validity + " " + this.LANG.getLangText("COMBOS_HOME_VALIDITY_DAYS");
      this.packageCode = this.currentCombo.slo;
      this.paymentId = this.currentCombo.idPaymentManager;
      //para obtener la descripcion commercial del bono principal
      for (let k in this.currentCombo.bonuses) {
        if (this.currentCombo.bonuses[k].isMain == 'S') {
          this.idPackageDesc = this.currentCombo.bonuses[k].commercialDescription;
          break;
        }
      }
    }

    this.numericPattern = constants.REGEX_NUMERIC_PATTERN;
    this.comboForm = this.formbuilder.group({
      inputAlternativeLine: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputLines: ['', [Validators.required]],
    });

    //metodo de pago tarjeta por defecto
    this.changePaymentMethodClass(4);
    //valida si esta loguado para msotrar las lineas
    this.isLoggedLines = false;
    if (this.LANG.isLogged()) {
      this.isLoggedLines = true;
      this.changeCheckClass(1);

      //obtiene las lineas de sesion
      let userData = JSON.parse(localStorage.getItem("userData"));
      for (var k in userData.associatedCellPhones) {
        this.listLines.push({ "id": userData.associatedCellPhones[k].id, "linea": userData.associatedCellPhones[k].id });
      }

      this.getStoredCards(userData.documentId);
      this.getRecurrenceConfig();
    }
    this.addEventListenerToTecnocom();
  }
  ngOnDestroy() {
    window.removeEventListener('message', this.onResponseTecnocom);
  }

  /**
   * Description: Método que escucha mensajes post desde el iframe de DCP
   */
  addEventListenerToTecnocom() {
    this.onResponseTecnocom = (e) => {
      // Método para evaluar si requiere o no el cancel
      if (this.idTransaction) {
        if (typeof e.data == "string") {
          if (e.data.indexOf("STATUS=01") > -1) {
            this.comboWizardService.startCancelAsync(this.idTransaction).subscribe(resp => {
              console.log("Cancel Async", resp);
            });
          }
        }
      }
    };
    window.addEventListener('message', this.onResponseTecnocom);
  }

  /**
   * Description: Método que obtiene la configuracion de encendido o apagado de recurrencia
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  getRecurrenceConfig() {
    this.isEnableRecurrence = false;
    this.comboWizardService.getRecurrenceEnableConfig().subscribe((valData => {
      if (valData['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE && valData["obj"] == constants.STRING_TRUE) {
        this.isEnableRecurrence = true;
      }
    }),
      (err) => {
        this.isEnableRecurrence = false;
      });
  }

  /**
   * Description: Método que obtiene los datos de las tarjetas guardadas
   * Autor: Diego Diaz
   * @param documentId documento de identificación
   * @return N/A
   */
  getStoredCards(documentId) {
    //obtiene valores permitidos de recargas
    this.comboWizardService.getStoredCards(documentId).subscribe((valData => {

      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.cardList = [];
        return;
      }

      this.cardList = valData["obj"];

      if (this.cardList == null || typeof this.cardList === 'undefined' || this.cardList.length <= 0) {
        this.isNewCard = true;
      }

    }),
      (err) => {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      });

  }

  /**
 * Description: Método que cambia la pantalla para continuar con el proceso de portabilidad
 * Autor: Diego Diaz
 * @param N/A
 * @return N/A
 */
  nextStep() {

    if (this.activeTab == 1) {

      if (this.inOutSelected == 1 && this.selectedPaymentMethod == 2) {
        this.selectedPaymentMethod = 4
      }

      if (this.inOutSelected == 2) {
        this.selectedPaymentMethod = 2
      }

      if (this.inOutSelected == 1 && this.currentCombo.value < this.validComboRecurrent) {
        this.selectedPaymentMethod = 2
      }

      //se desabilita la recurrencia si el parametro de bd lo indica
      if (this.isEnableRecurrence == false && this.selectedPaymentMethod == 4) {
        this.selectedPaymentMethod = 2;
      }

      if ((this.inOutSelected == 2 && this.comboForm.get('inputAlternativeLine').invalid) ||
        (this.inOutSelected == 1 && this.comboForm.get('inputLines').invalid)) {
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
        this.isShowModal = true;
        return;
      }

      //linea a mostrar
      if (this.inOutSelected == 2) {
        this.inputLine = this.comboForm.get('inputAlternativeLine').value;
      } else {
        this.inputLine = this.comboForm.get('inputLines').value
      }

      if (!this.LANG.isValidPhoneZero(this.inputLine)) {
        //si no tiene el prefijo 0 no puede seguir
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('PHONE_VALIDATOR_ERROR_ZERO');
        this.isShowModal = true;
        return false;
      }

      //setea el tooltip de balance
      if (this.LANG.isLogged()) {
        this.getLineBalance();
      }

      //obtiene valores permitidos de recargas
      this.isLoadingBtn = true;
      this.comboWizardService.validatePhoneInBrand(this.inputLine).subscribe((valData => {
        this.isLoadingBtn = false;


        if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE || valData['obj'].valid != true) {
          this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
          this.modalContent = this.LANG.getLangText('COMBOS_LABEL_MODAL_ERROR_LINE_NOT_IN_BRAND');
          this.isShowModal = true;
          return;
        }

        //seleeciona como activa la pestaña 2
        this.activeTab = 2;
        //cambia a la pestaña 2
        this.changeTab(2);
        //habilita boton de regresar
        this.isBackDisabled = false;
        //muestra el icono check del paso 1
        this.isStep1Checked = true;

      }),
        (err) => {
          this.isLoadingBtn = false;
          this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
          this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
          this.isShowModal = true;
          return;
        });

    } else if (this.activeTab == 2) {

      if (this.inOutSelected == 1 && this.selectedPaymentMethod == 2 && this.currentCombo.value >= this.validComboRecurrent) {
        this.selectedPaymentMethod = 4
      }

      //se desabilita la recurrencia si el parametro de bd lo indica
      if (this.isEnableRecurrence == false && this.selectedPaymentMethod == 4) {
        this.selectedPaymentMethod = 2;
      }

      //variable que utilizamos para identificar cuando mostrar o no la opcion de guardar tarjeta segun pasarela de pago (DSH o Datafast)
      this.viewSaveCard = this.inOutSelected == 1 && this.selectedPaymentMethod == 4 && this.validationComboRecurrent && this.isLoggedLines && this.currentCombo.value >= this.validComboRecurrent


      this.viewOnly(this.LANG.getLangText('EMPTY_VALID_ONLY_RECURRENT'), this.LANG.getLangText('EMPTY_VALID_ONLY_RECURRENT'))
      /**
       * Once the user selects recurring payment, they will be validated if they already have a recurring payment, 
       * if they do not select recurring payment, continue with the existing flow (Diego Diaz)
       */
      if (this.validationComboRecurrent && this.inOutSelected == 1 && this.currentCombo.value >= this.validComboRecurrent) {

        let productExist = ""
        this.isLoadingBalance = true;
        this.comboWizardService.getFindSubscription(this.inputLine).subscribe((valData => {

          this.isLoadingBalance = false;
          if (valData['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE && this.isEnableRecurrence) {
            let response = valData['obj']
            productExist = response[0]
            this.getExistComboRecurrent(true, productExist);
          } else {
            this.getExistComboRecurrent(false, productExist);
          }
        }),
          (err) => {
            this.isLoadingBalance = false;
            this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
            this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
            this.isShowModal = true;
            return;
          });

        // this.getExistComboRecurrent(true, productExist);

      } else {
        this.viewOnly(this.LANG.getLangText('EMPTY_VALID_ONLY_RECURRENT'), this.LANG.getLangText('VALID_ONLY_RECURRENT'))
        /////////////////////////////////////////////HU COMPRAS DE COMBOS//////////////////////////////////
        //seleeciona como activa la pestaña 3
        this.activeTab = 3;
        //cambia a la pestaña 3
        this.changeTab(3);
        //habilita boton de regresar
        this.isBackDisabled = false;
        //muestra el icono check del paso 2
        this.isStep2Checked = true;

        if (this.selectedPaymentMethod == 1) {
          this.labelBtnEnd = this.LANG.getLangText('COMBOS_LABEL_BTN_FINISH_PAYMENT');
        } else {

          //sin login llama directamente el iframe.
          this.isPayFrameShow = false;
          if (!this.LANG.isLogged()) {
            this.isPayFrameShow = true;
            this.getPaymentIframe();
            return;
          }

          if (this.cardList != null && this.cardList.length <= 0) {
            this.isPayFrameShow = true;
            this.getPaymentIframe();
            return;
          }
        }

      }

    } else if (this.activeTab == 3) {

      if (this.selectedPaymentMethod == 1) {
        this.executePaymentFromBalance();
      } else {
        if (this.selectedCard == null && !this.isNewCard && !this.isPayFrameShow) {
          this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
          this.modalContent = this.LANG.getLangText('RECHARGE_MODAL_CONTENT_CARD_VALIDATION');
          this.isShowModal = true;
          return;
        }
        this.isPayFrameShow = true;
        this.getPaymentIframe();
      }
    }

  }

  getExistComboRecurrent(bool, productExist) {

    if (!bool) {
      //We call the service that brings the recurrence payment form
      this.getRecurrenceForm()

      //seleeciona como activa la pestaña 3
      this.activeTab = 3;
      //cambia a la pestaña 3
      this.changeTab(3);
      //habilita boton de regresar
      this.isBackDisabled = false;
      //muestra el icono check del paso 2
      this.isStep2Checked = true;

      if (this.selectedPaymentMethod == 1) {
        this.labelBtnEnd = this.LANG.getLangText('COMBOS_LABEL_BTN_FINISH_PAYMENT');
      } else {

        //sin login llama directamente el iframe.
        this.isPayFrameShow = false;
        if (!this.LANG.isLogged()) {
          this.isPayFrameShow = true;
          this.getPaymentIframe();
          return;
        }

        if (this.cardList != null && this.cardList.length <= 0) {
          this.isPayFrameShow = true;
          this.getPaymentIframe();
          return;
        }
      }
    } else {
      // function exist combo recurrent
      this.viewExistRecurrentComb(productExist)
    }
  }

  /**
   * Description : Metho to view exist comb recurrent
   * Autor: Luis Hernandez
   * @param N/A
   * @return N/A
   */
  getRecurrenceForm() {

    this.isShowModalPay = true;
    let jsonDataPro = {};
    let userData = JSON.parse(localStorage.getItem("userData"));

    jsonDataPro = {
      "msisdn": this.inputLine,
      "docType": userData.documentType,
      "documentId": userData.documentId,
      "name": userData.givenName ? userData.givenName : userData.name,
      "lastName": userData.lastName ? userData.lastName : "",
      // "lastName" : userData.lastName ? userData.lastName:userData.name,
      "address": userData.addressNormalized,
      "email": userData.email,
      "idPaymentManager": this.paymentId
    };

    this.isLoadingBalance = true;
    this.comboWizardService.getRecurrenceForm(jsonDataPro).subscribe((valData => {
      this.isLoadingBalance = false;
      this.actionUrl = valData["obj"].actionUrl
      this.dataBrands = valData["obj"].dataBrands
      const url = valData["obj"].scriptUrl;
      let node = document.createElement('script');
      node.src = url;
      document.getElementsByTagName('head')[0].appendChild(node);

      this.band = false
      let _self = this

      this.internal = setInterval(() => {
        if (_self.band == false) {
          if ($(".wpwl-wrapper-submit").length > 0) {
            if ($("#img-pay-datafast").length == 0) {
              $('.wpwl-wrapper-submit').find('.wpwl-button').before("<br/><br/><img id='img-pay-datafast' src='https://www.datafast.com.ec/images/verified.png' style='display:block;margin:0 auto; width:100%;'>");
            }
            _self.band = true
            clearInterval(this.internal);
          } else {
            clearInterval(this.internal);
          }
        }
      }, 2000);


    }),
      (err) => {
        this.isLoadingBalance = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      });

  }

  /**
   * Description : Metho to view exist comb recurrent
   * Autor: Luis Hernandez
   * @param N/A
   * @return N/A
   */
  viewExistRecurrentComb(productExist) {
    this.isLoadingBalance = false;
    this.messageService.sendMessage(this.LANG.getLangText('VALID_RECURRENT_TYPE'), productExist);
    this.isShowModal = true;
  }


  /**
   * Description : Metho to view exist comb recurrent
   * Autor: Luis Hernandez
   * @param N/A
   * @return N/A
   */
  viewOnly(productExist, message) {
    this.isLoadingBalance = false;
    this.modalTitle = "";
    this.modalContent = "";
    this.messageService.sendMessage(message, productExist);
    this.isShowModal = false;
  }

  /**
   * Description: Método que setea el tooltip de balance
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  getLineBalance() {

    this.isLoadingBalance = true;
    this.comboWizardService.getBalance(this.inputLine).subscribe((valData => {
      this.isLoadingBalance = false;
      if (valData['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
        this.lineBalance = valData["obj"].remainedAmount;
        this.lineBalanceUnit = valData["obj"].remainedUnits;
      }
    }),
      (err) => {
        this.isLoadingBalance = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      });

  }

  /**
   * Description: Método que setea el tooltip de saldo disponible
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  ngAfterViewChecked() {
    var balanceTooltipText: any = this.LANG.getLangText('COMBO_LABEL_TOOLTIP_BALANCE') + " $" + this.lineBalance + " " + this.lineBalanceUnit;
    $('#tooltipBalance').popover({
      html: true,
      content: balanceTooltipText,
      trigger: 'hover'
    });
  }

  /**
   * Description: Método que cambia de tab o paso en el wizard
   * Autor: Diego Diaz
   * @param tab paso que se desea mostrar
   * @return N/A
   */
  changeTab(tab) {
    var aStep = document.getElementById('step' + tab + '-tab');
    (<any>aStep).href = "#step" + tab;
    aStep.click();
  }

  /**
  * Description: Método que cambia la pantalla para volver con el paso 1 o 2 del proceso de portabilidad
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  backStep() {
    this.selectedCard = null;
    this.isHideBtn = false;
    this.isPayFrameShow = false;

    //oculta los iconos check de los tab
    if (this.activeTab <= 1 || this.paymentFinished) {
      this._router.navigate([constants.ROUTE_URL_COMBOS]);
    } else if (this.activeTab == 2) {
      this.isStep1Checked = false;
    } else if (this.activeTab == 3) {
      this.isStep2Checked = false;
    }

    //cambia de pestaña
    if (this.activeTab > 1) {
      this.changeTab((this.activeTab - 1));
      this.activeTab = (this.activeTab - 1);
      this.labelBtnEnd = this.LANG.getLangText('PORTABILITY_LABEL_CONTINUE');
    }
  }


  /**
   * Description: Método que ocualta el modal
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  hideModal() {
    this.isShowModal = false;
    this.isComboRecurrentActive = false;
    if (this.isModalReload) {
      this._router.navigate(['/']);
    }
  }

  /**
   * Description: Método que asigna la clase activa al checkbox
   * Autor: Diego Diaz
   * @param id identificador del check
   * @return N/A
   */
  changeCheckClass(id) {
    /**
     * @ModifiedBy Julian Ciro
     * Se quita la instancia de la variable this.isLoggedLines = false;
     * Se agrega this.isInputLineRegister = true/false al final de cada if para indicar que input se muestra;
     */
    if (id == 1) {
      const userData = JSON.parse(localStorage.getItem("userData"));
      this.authGuardService.validateSessionUserLogged(userData).subscribe((valData => {
        this.isLoadingDeleteBtn = false;

        if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
          this.changeCheckClass(2);
          return;
        }

        $("#inoutBtn1").addClass("active");
        $("#inoutBtn2").removeClass("active");
        $("#inoutRadios1").prop("checked", "checked");
        this.isInputLineRegister = true;

      }));
    } else if (id == 2) {
      $("#inoutBtn2").addClass("active");
      $("#inoutBtn1").removeClass("active");
      $("#inoutRadios2").prop("checked", "checked");
      this.isInputLineRegister = false;
    }
    this.setSelectedInOutRadio(id);
  }

  /**
  * Description: Método que asigna la clase activa al checkbox de metodo de pago
  * Autor: Diego Diaz - Refactor - Luis Fernando Hernandez 
  * @param id identificador del check
  * @return N/A
  */
  changePaymentMethodClass(id) {

    //se desabilita la recurrencia si el parametro de bd lo indica
    if (this.isEnableRecurrence == false && (id == 4)) {
      id = 2;
    }

    $("#payMBtn1").removeClass("active");
    $("#payMBtn2").removeClass("active");
    $("#payMBtn3").removeClass("active");


    $("#payMBtn" + id).addClass("active");
    $("#payMBtnRadios" + id).prop("checked", "checked");

    if (id == 1) {
      this.validationComboRecurrent = false
      this.validationComboOnly = false
      this.viewActionsRecurrent = false
    } else if (id == 2 || id == 4) {
      this.validationComboRecurrent = true
      this.validationComboOnly = false
      /**
       * shows the unique and recurrence buttons, when selecting credit card
       */
      $("#payMBtn4").addClass("active");
      $("#payMBtnRadios4").prop("checked", "checked");

      $("#payMBtn2").addClass("active");
      $("#payMBtnRadios2").prop("checked", "checked");
      this.viewActionsRecurrent = true
    } else if (id == 3) {
      this.validationComboRecurrent = false
      this.validationComboOnly = true
      /**
       * the credit card button is selected when selecting only
       */
      $("#payMBtn4").removeClass("active");
      $("#payMBtn2").addClass("active");
      $("#payMBtnRadios2").prop("checked", "checked");
      this.validationComboOnly = true
    } else if (id == 4) {
      this.validationComboRecurrent = true
      this.validationComboOnly = false
      /**
       * as the story indicates to the brand, 
       * the recurrence button must be marked the credit card button
       */
      $("#payMBtn2").addClass("active");
      $("#payMBtnRadios2").prop("checked", "checked");
    }
    this.selectedPaymentMethod = id;

  }


  /**
  * Description: Método que asigna el valor de la opcion seleccionada
  * Autor: Diego Diaz
  * @param id id del tipo de telefono seleccionado
  * @return N/A
  */
  setSelectedInOutRadio(id) {
    this.inOutSelected = id;
  }

  /**
   * Description: Método que asigna la tarjeta
   * Autor: Diego Diaz
   * @param id tarjeta seleccionada
   * @return N/A
   */
  selectCard(id) {
    this.selectedCard = id;
    //removemos el seleccionado anterior
    $(".card-crud .btn").each(function () {
      $(this).removeClass("active");
    });

    $("#ccard-" + id).addClass("active");
  }

  /**
 * Description: Método que asigna la tarjeta nueva
 * Autor: Diego Diaz
 * @param N/A
 * @return N/A
 */
  selectAsNewCard() {
    this.isNewCard = true;
    this.nextStep();
  }

  /**
 * Description: Método que indica si se guarda o no la tarjeta
 * Autor: Diego Diaz
 * @param N/A
 * @return N/A
 */
  // saveCreditCard() {
  //   this.isSaveCCard = false;
  //   if ($('#saveCCard').is(":checked")) {
  //     this.isSaveCCard = true;
  //     if (this.isPayFrameShow) {
  //       let myIframe1: any = document.getElementById('payment-form');
  //       myIframe1.contentWindow.document.open();
  //       myIframe1.contentWindow.document.write("");
  //       myIframe1.contentWindow.document.close();
  //       this.getPaymentIframe();
  //     }
  //   }
  // }

  saveCreditCard() {
    this.isSaveCCard = false;
    if ($('#saveCCard').is(":checked")) {
      this.isSaveCCard = true;
      if (this.isPayFrameShow) {
        this.getPaymentIframe();
      }
    } else {
      this.isSaveCCard = false;
      if (this.isPayFrameShow) {
        this.getPaymentIframe();
      }
    }
  }

  /**
   * Description: Método que elimina una tarjeta
   * Autor: Diego Diaz
   * @param id identificador de la tarjeta
   * @return N/A
   */
  deleteCard(id) {
    //obtiene valores permitidos de recargas
    this.isLoadingDeleteBtn = true;
    this.comboWizardService.deleteStoredCards(id).subscribe((valData => {
      this.isLoadingDeleteBtn = false;

      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('RECHARGE_CARD_REMOVE_ERROR');
        this.isShowModal = true;
        return;
      }

      let auxList = this.cardList;
      this.cardList = [];
      for (var k in auxList) {
        if (auxList[k].id != id) {
          this.cardList.push(auxList[k]);
        }
      }

    }),
      (err) => {
        this.isLoadingDeleteBtn = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      });
  }

  /**
  * Description: Método que obtiene el formulario de pagos
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  getPaymentIframe() {

    let jsonData = {};
    this.isPaymentFormLoading = true;
    if (this.LANG.isLogged()) {
      let userData = JSON.parse(localStorage.getItem("userData"));
      jsonData = {
        "msisdn": this.inputLine,
        "identification": userData.documentId,
        "additionalData": this.paymentId,
        "valueToRecharge": this.selectedAmouunt,
        "isStoreCard": this.isSaveCCard,
        "paymentParam": constants.PAYMENT_FORM_REST_CONTRATATION,
        "email": userData.email,
      };

      if (this.selectedCard != null && this.selectedCard > 0) {
        jsonData["idCreditCardSaved"] = this.selectedCard;
      }

    } else {
      jsonData = {
        "msisdn": this.inputLine,
        "valueToRecharge": this.selectedAmouunt,
        "additionalData": this.paymentId,
        "isStoreCard": false,
        "paymentParam": constants.PAYMENT_FORM_REST_CONTRATATION
      };
    }

    this.comboWizardService.getPaymentForm(jsonData).subscribe((valData => {

      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      }

      this.isHideBtn = true;

      //datos de condiguracion estatica
      this.urlFormPayment = valData["obj"].urlForm;
      var result = [];
      for (var i in valData["obj"].formData) {
        if (i === "IDTABLA") {
          this.idTransaction = valData["obj"].formData[i];
        } else {
          result.push([i, valData["obj"].formData[i]]);
        }
      }
      this.paymentFormInputList = result;

      let _self = this;
      setTimeout(function () {
        $("#submit-payment-form").click();
        _self.isPaymentFormLoading = false;
      }, 1000);

    }),
      (err) => {
        this.isPaymentFormLoading = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      });

  }


  /**
  * Description: Método que ejecuta el pago del bono o combo por medio del Saldo
  * Autor: Diego Diaz
  * @param N/A
  * @return Confirmación del pago
  */
  executePaymentFromBalance() {

    //validaciones de campos
    if (!$('input#authDebit').is(':checked')) {
      this.modalTitle = this.LANG.getLangText('CALL_LOG_DETAIL_MODAL_AUTH_TITLE');
      this.modalContent = this.LANG.getLangText('COMBOS_LABEL_ERROR_AUTH_DEBIT');
      this.isShowModal = true;
      return;
    }

    let userData = JSON.parse(localStorage.getItem("userData"));
    let dataJson = {
      "msisdn": this.inputLine,
      "offerIdCC": this.packageCode,
      "autirizationDebit": constants.YES,
      "identification": userData.documentId,
      "email": userData.email
    };

    this.isLoadingBtn = true;
    this.comboWizardService.contractPackageTopupBalance(dataJson).subscribe((valData => {
      this.isLoadingBtn = false;

      //error tx en proceso
      if (valData['responseCode'] == constants.PAYMENT_TX_IN_PROCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('PAYMENT_COMMONS_TX_IN_PROCESS');
        this.isShowModal = true;
        return;
      }

      //error oferta no disponible para la linea en cuestion
      if (valData['responseCode'] == constants.PAYMENT_NO_VALID_OFFER_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('PAYMENT_COMMONS_NO_VALID_OFFER');
        this.isShowModal = true;
        return;
      }

      //error interno serivcio
      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      }

      this.dateExecutedPatment = valData["obj"].dateTransaction;
      this.paymentFinished = true;
      this.isHideBtn = true;

    }),
      (err) => {
        this.isLoadingBtn = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      });
  }


  /**
  * Description: Método que formatea la imagen de la franquicia
  * Autor: Diego Diaz
  * @param imgData blob de la imagen
  * @return imagen formateada
  */
  formatImg(base64Img) {
    return constants.BASE64_INIT + base64Img;
  }
}
